import React from 'react';
import { useSelector } from 'react-redux';

import { StoreState } from 'state/rootReducer';
import { useLastEventToday } from 'features/feedDataLayer';
import { StepSignature } from './constants';
import SignatureInitial from './SignatureInitial';
import SignaturePreviewDownload from './SignaturePreviewDownload';
import SignatureSelectCertificates from './SignatureSelectCertificates';
import SignatureSetup from './SignatureSetup';
import SignatureLoader from './SignatureLoader';

const SignatureStepper: React.FC = () => {
  const stepper: StepSignature = useSelector<StoreState>(
    (state) => state.records.signature.stepper,
  );
  useLastEventToday();

  const signatureStep = {
    [StepSignature.Initial]: <SignatureInitial />,
    [StepSignature.Setup]: <SignatureSetup />,
    [StepSignature.Certificates]: <SignatureSelectCertificates />,
    [StepSignature.Preview]: <SignaturePreviewDownload />,
    [StepSignature.Loading]: <SignatureLoader />,
  };

  return signatureStep[stepper];
};

export default SignatureStepper;
